module.exports = "/templates/bds/public/images/99f06ee1344e12dee060155236aa5e70.png";